import { useGetHttp } from "../../../../../hooks/http/http.hook";
import type { IAssetMinimal } from "../../../../../types/models/asset.models.types";
import type { IUser } from "../../../../../types/models/user.models.types";

export interface IBrands {
	id: string;
	name: string;
	domain: string;
	description: string;
	logo: IAssetMinimal;
	pan: string;
	gst: string;
	user: IUser;
	createdAt: Date;
	updatedAt: Date;
}

interface IResponse {
	brands: Array<IBrands>;
}

export function useGetWorkspaceHttp() {
	return useGetHttp<IResponse>({
		path: "/brand/brands",
	});
}
